import Vue from "vue";
import i18n from '../assets/i18n'
import VueRouter from "vue-router";
import Index from "../views/index.vue";
import Home from '../views/Home.vue'
import MaterialProject from '../views/MaterialProject.vue'
import Project from '../views/project.vue'
import ServiceItems from '../views/ServiceItems.vue'
import TenderProject from '../views/TenderProject.vue'
import TenderAnnouncement from '../views/show/TenderAnnouncement.vue'
import InquiryAnnouncement from '../views/show/InquiryAnnouncement.vue'
import Register from '../views/register.vue'
import PersonalCenter from '../views/PersonalCenter/index.vue'
import MyBid from '../views/PersonalCenter/MyBid'
import CompanyQualification from '../views/PersonalCenter/CompanyQualification'
import PersonalInformation from '../views/PersonalCenter/PersonalInformation'
import PasswordModification from '../views/PersonalCenter/PasswordModification.vue'
import MyQuestion from '../views/PersonalCenter/MyQuestion'
import MyFollowing from '../views/PersonalCenter/MyFollowing'
import BidDetails from "@/views/PersonalCenter/MyBid/BidDetails.vue";
import forgotPassword from "@/views/forgotPassword.vue";
import quotation from '@/views/PersonalCenter/quotation.vue';
import HandlingMatters from '@/views/PersonalCenter/HandlingMatters/index.vue'
import PreviewDetails from '../components/PreviewDetails.vue'
import MyQuestionDet from '@/views/PersonalCenter/MyQuestion/MyQuestionDet'
import showList from '@/views/show/showList'
import EnterpriseCertification from '@/views/PersonalCenter/EnterpriseCertification/index.vue'
import EnterpriseCertificationDet from '@/views/PersonalCenter/EnterpriseCertification/det.vue'
import ImprovePrices from '@/views/PersonalCenter/MyBid/ImprovePrices.vue'
import SpareParts from '@/views/PersonalCenter/SpareParts/index.vue'
import PowerOfAttorney from '@/views/PersonalCenter/PowerOfAttorney/index.vue'
import SparePartsDet from '@/views/PersonalCenter/SpareParts/det.vue'
Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "Index",
    component: Index,
    children:[
      {
        path: "/",
        name: "Home",
        component: Home,
      },
      {
        // 物资项目
        path: "/MaterialProject",
        name: "MaterialProject",
        component: MaterialProject,
      },
      {
        // 工程项目
        path: "/Project",
        name: "Project",
        component: Project,
      },
      {
        // 服务项目
        path: "/ServiceItems",
        name: "ServiceItems",
        component: ServiceItems,
      },
      {
        // 招标项目 更多
        path: "/TenderProject",
        name: "TenderProject",
        component: TenderProject,
      },
      {
        // 招标公告展示
        path: "/TenderAnnouncement",
        name: "TenderAnnouncement",
        meta:{top:'dome1'} ,
        component: TenderAnnouncement,
      },
      {
        // 询价公告展示
        path: "/InquiryAnnouncement",
        name: "InquiryAnnouncement",
        meta:{top:'dome1'} ,
        component: InquiryAnnouncement, 
      },
      {
        // 详情点回去的分类列表
        path: "/showList",
        name: "showList",
        meta:{top:'dome1'} ,
        component: showList, 
        
      },
      {
        //个人中心
        path: "/PersonalCenter",
        name: "PersonalCenter",
        component: PersonalCenter, 
        meta:{top:'dome1'},
        children:[{
          // 我的投标
          path: "/MyBid",
          name: "MyBid",
          component: MyBid, 
          meta:{identifying:'MyBid',top:'dome1',urlName:[{name:i18n.t('view.我的投标'),path:'MyBid'}]} 
        },
        {
          // 处理事项
          path: "/HandlingMatters",
          name: "HandlingMatters",
          component: HandlingMatters, 
          meta:{identifying:'HandlingMatters',top:'dome1',urlName:[{name:i18n.t('view.处理事项'),path:'HandlingMatters'}]} 
        },
        {
          // 投标详情
          path: "/BidDetails",
          name: "BidDetails",
          component: BidDetails, 
          meta:{identifying:'MyBid',top:'dome1',urlName:[{name:i18n.t('view.投标详情'),path:'MyBid'},{name:i18n.t('view.投标详情'),path:'BidDetails'}]} 
        },
         {
          // 完善价格
          path: "/ImprovePrices",
          name: "ImprovePrices",
          component: ImprovePrices, 
          meta:{identifying:'MyBid',top:'dome1',urlName:[{name:i18n.t('view.我的投标'),path:'MyBid'},{name:i18n.t('view.完善价格'),path:'ImprovePrices'}]} 
        },
        
        {
          // 企业认证
          path: "/EnterpriseCertification",
          name: "EnterpriseCertification",
          component: EnterpriseCertification,
          meta:{identifying:'EnterpriseCertification',top:'dome1',urlName:[{name:i18n.t('view.企业认证'),path:'EnterpriseCertification'}]} 
        },
        // 企业信息
        {
          path: "/EnterpriseCertificationDet",
          name: "EnterpriseCertificationDet",
          component: EnterpriseCertificationDet,
          meta:{identifying:'EnterpriseCertificationDet',top:'dome1',urlName:[{name:i18n.t('view.企业信息'),path:'EnterpriseCertificationDet'}]} 
        },
        // 授权委托书管理
        {
          path: "/PowerOfAttorney",
          name: "PowerOfAttorney",
          component: PowerOfAttorney,
          meta:{identifying:'PowerOfAttorney',top:'dome1',urlName:[{name:i18n.t('view.授权委托书管理'),path:'PowerOfAttorney'}]}
        },
        {
          // 备件信息完善
          path: "/SpareParts",
          name: "SpareParts",
          component: SpareParts,
          meta:{identifying:'SpareParts',top:'dome1',urlName:[{name:i18n.t('view.备件信息完善'),path:'SpareParts'}]} 

        },
         {
          // 备件信息完善详情
          path: "/SparePartsDet",
          name: "SparePartsDet",
          component: SparePartsDet,
          meta:{identifying:'SpareParts',top:'dome1',urlName:[{name:i18n.t('view.备件信息完善'),path:'SpareParts'},{name:i18n.t('view.备件信息完善详情'),path:'SparePartsDet'}]} 
        },
        {
          // 公司资质
          path: "/CompanyQualification",
          name: "CompanyQualification",
          component: CompanyQualification,
          meta:{identifying:'CompanyQualification',top:'dome1',urlName:[{name:i18n.t('view.企业认证'),path:'CompanyQualification'}]} 
        },
        {
          // 个人信息
          path: "/PersonalInformation",
          name: "PersonalInformation",
          component: PersonalInformation, 
          meta:{identifying:'PersonalInformation',top:'dome1',urlName:[{name:i18n.t('view.个人信息'),path:'PersonalInformation'}]} 
        },
        {
           // 修改密码
           path: "/PasswordModification",
           name: "PasswordModification",
           component: PasswordModification, 
           meta:{identifying:'PasswordModification',top:'dome1',urlName:[{name:i18n.t('view.密码修改'),path:'PasswordModification'}]} 
        },
        {
           // 我的提问
          path: "/MyQuestion",
          name: "MyQuestion",
          component: MyQuestion, 
          meta:{identifying:'MyQuestion',top:'dome1',urlName:[{name:i18n.t('view.我的问题'),path:'MyQuestion'}]} 
        },
        {
          // 问题详情
          path: "/MyQuestionDet",
          name: "MyQuestionDet",
          component: MyQuestionDet, 
          meta:{identifying:'MyQuestion',top:'dome1',urlName:[{name:i18n.t('view.我的问题'),path:'MyQuestion'},{name:i18n.t('view.问题详情'),path:'MyQuestionDet'}]} 
        },
        {
          // 我的关注
          path: "/MyFollowing",
          name: "MyFollowing",
          component: MyFollowing, 
          meta:{identifying:'MyFollowing',top:'dome1',urlName:[{name:i18n.t('view.我的关注'),path:'MyFollowing'}]} 
          
        }],
      },
      {
        // 报价页面
        path: "/quotation",
        name: "quotation",
        component: quotation, 
        meta:{top:'dome1'} 

      }

      
    ]
  },
  {
    // 注册
    path:'/Register',
    name:'Register',
    component:Register
  },
  {
    // 忘记密码
    path:'/forgotPassword',
    name:'forgotPassword',
    component:forgotPassword
    
  },
  {
    // 预览详情
    path:'/PreviewDetails',
    name:'PreviewDetails',
    component:PreviewDetails
  }
];

const router = new VueRouter({
  mode: 'history', // 去掉url中的#
  routes,
});

export default router;
